<template>
    <!-- PageAbout -->
    <div class="PageATemp">
        <div class="site-container">    
            <!-- PgStaTestTitle -->
            <div class="ATempTitle">
                <h2 class="ATempTitle-tit">STA 자기발견 기질검사</h2>
                <p class="ATempTitle-sub">Self-discovery Temperament Assessment</p>
            </div>
            <!-- .PgStaTestTitle -->
            <div class="ATempCharacter">
                <div class="ATempCharacterImg">
                    <img src="/images/view/statest/img-starCharacter.png" class="ATempCharacterImg-img" />
                </div>
                <download-pdf-button :pdf-url="pdfUrl" :pdf-file-name="pdfFileName" :button-label="buttonLabel" />
            </div>
            <!-- STA Creator -->
            <h3 class="ATempSubTitle">STA Creator</h3>
            <div class="ATempAbout ATempSec">
                <div class="ATempAboutFlex">
                    <div class="ATempAboutFlexThumb">
                        <img class="ATempAboutFlexThumb-img" src="/images/view/abouttemp/abouttemp1.jpg" alt="" />
                    </div>
                    <div class="ATempAboutFlexCnt">
                        <div class="ATempAboutFlexCnt-name">최은정</div>
                        <ul class="ATempAboutFlexCnt-list">
                            <li class="ATempAboutFlexCnt-item">
                                <span class="ATempAboutFlexCnt-body">
                                    <span class="ATempAboutFlexCnt-year">2017년</span>
                                    <span class="ATempAboutFlexCnt-text">위드유치료교육연구소 설립</span>
                                </span>
                            </li>
                            <li class="ATempAboutFlexCnt-item">
                                <span class="ATempAboutFlexCnt-body">
                                    <span class="ATempAboutFlexCnt-year">2018년</span>
                                    <span class="ATempAboutFlexCnt-text">기질검사 저작권 등록</span>
                                </span>
                            </li>
                            <li class="ATempAboutFlexCnt-item">
                                <span class="ATempAboutFlexCnt-body">
                                    <span class="ATempAboutFlexCnt-year">2019년</span>
                                    <span class="ATempAboutFlexCnt-text">육아고민? 기질육아가 답이다! 도서 발간</span>
                                </span>
                            </li>
                            <li class="ATempAboutFlexCnt-item">
                                <span class="ATempAboutFlexCnt-year">2020년</span>
                                    <span class="ATempAboutFlexCnt-body">
                                    <span class="ATempAboutFlexCnt-text">민간자격과정 개설</span>
                                    <span class="ATempAboutFlexCnt-text">기질분석상담사 2급, 1급(교육부)</span>
                                    <span class="ATempAboutFlexCnt-text">STA기질교육전문지도사 2급, 1급(교육부)</span>
                                    <span class="ATempAboutFlexCnt-text">STA기질부모교육전문가(여성가족부)</span>
                                </span>
                            </li>
                            <li class="ATempAboutFlexCnt-item">
                                <span class="ATempAboutFlexCnt-year">2026년</span>
                                <span class="ATempAboutFlexCnt-body">
                                    <span class="ATempAboutFlexCnt-text">기질을 적용한 교실정원 도서 발간</span>
                                    <span class="ATempAboutFlexCnt-text">민간자격과정 개설</span>
                                    <span class="ATempAboutFlexCnt-text">기질교육중재전문가 2급, 1급</span>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- .STA Creator -->
            <!-- Mission Statement-->
            <h3 class="ATempSubTitle">Mission Statement</h3>
            <div class="ATempMission ATempSec">
                <div class="ATempMissionFlex">
                    <div class="AtempGreen First">
                        <p class="AtempGreen-title">기질에 대한 지혜<br />기질검사 개발은</p>
                        <p class="AtempGreen-txt">나를 이해하는 과정이고<br />나를 발견하는 과정이었고<br />나를 사랑하는 과정이었고<br />나의 성품을 살아가는 삶입니다.</p>
                    </div>
                    <div class="AtempGreen Last">
                        <p class="AtempGreen-title">빌립보서 1장 9~10절 성경말씀</p>
                        <p class="AtempGreen-txt">내가 기도하노라 너희 사랑을 지식과 모든 총명으로 점점 더 풍성하게 하사 <br />너희로 지극히 선한 것을 분별하며 또 진실하여 허물없이 그리스도의 날까지 이르고</p>
                        <div class="ATempMissionMeta">
                            <div class="ATempMissionMetaThumb">
                                <img src="/images/view/abouttemp/abouttem2.jpg" class="ATempMissionMetaThumb-img" />
                            </div>
                            <div class="ATempMissionMetaCnt">
                                <p class="ATempMissionMetaCnt-title">STA 자기 발견 기질검사 개발의 시작은 하나님의 지혜였습니다.</p>
                                <p class="ATempMissionMetaCnt-text">하나님께서 지으신 사람의 타고난 성품을 발견하고, 창조하신 모습대로 선하고 아름답게 관계를 맺고 살아갈 때 우리는 질실하게 서로 사랑하며 살아갈 수 있습니다.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- .Mission Statement -->
            <!-- FourTemp-->
            <h3 class="ATempSubTitle">Four Temperament</h3>
            <div class="FourTemp ATempSec">
                <div class="FourTempList">
                    <ul class="FourTempList-inner">
                        <li class="FourTempList-item">
                            <div class="FourTempListItem">
                                <div class="FourTempListItemThumb">
                                    <img src="/images/view/abouttemp/abouttem3_1.jpg" class="FourTempListItemThumb-img" alt="" />
                                </div>
                                <div class="FourTempListItem-title">Forbearance</div>
                                <div class="FourTempListItem-sub">관용기질</div>
                            </div>
                        </li>
                        <li class="FourTempList-item">
                            <div class="FourTempListItem">
                                <div class="FourTempListItemThumb">
                                    <img src="/images/view/abouttemp/abouttem3_2.jpg" class="FourTempListItemThumb-img" alt="" />
                                </div>
                                <div class="FourTempListItem-title">Adherence</div>
                                <div class="FourTempListItem-sub">몰입기질</div>
                            </div>
                        </li>
                        <li class="FourTempList-item">
                            <div class="FourTempListItem">
                                <div class="FourTempListItemThumb">
                                    <img src="/images/view/abouttemp/abouttem3_3.jpg" class="FourTempListItemThumb-img" alt="" />
                                </div>
                                <div class="FourTempListItem-title">Communion</div>
                                <div class="FourTempListItem-sub">교감기질</div>
                            </div>
                        </li>
                        <li class="FourTempList-item">
                            <div class="FourTempListItem">
                                <div class="FourTempListItemThumb">
                                    <img src="/images/view/abouttemp/abouttem3_4.jpg" class="FourTempListItemThumb-img" alt="" />
                                </div>
                                <div class="FourTempListItem-title">Embrace</div>
                                <div class="FourTempListItem-sub">포용기질</div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="FourTempMeta">
                    <ul class="FourTempMeta-inner">
                        <li class="FourTempMeta-item">
                            <div class="FourTempMetaItem">
                                <div class="FourTempMetaItem-title">4가지 기질유형 이름은 '고유한 성품'</div>
                                <p class="FourTempMetaItem-text">4가지 기질유형의 이름은 기질유형이 갖고 있는 고유한 성품 단어이다.<br />STA 기질은 하나님께서 창조하신 성품을 선하고 아름답게 발견하도록 한다.</p>
                            </div>
                        </li>
                        <li class="FourTempMeta-item">
                            <div class="FourTempMetaItem">
                                <div class="FourTempMetaItem-title">2세(18개월)부터 성인까지</div>
                                <p class="FourTempMetaItem-text">STA-I(영아용)</p>
                                <p class="FourTempMetaItem-text">STA-C(유아용)</p>
                                <p class="FourTempMetaItem-text">STA-S(초등학생용)</p>
                                <p class="FourTempMetaItem-text">STA-Y(청소년용)</p>
                                <p class="FourTempMetaItem-text">STA-A(성인용)</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- .FourTemp-->
            <!-- TempPresemt-->
            <h3 class="ATempSubTitle">STA Present</h3>
            <div class="TempPresemt ATempSec">
                <ul class="TempPresemt-inner">
                    <li class="TempPresemt-item">
                        <div class="TempPresemtItem">
                            <div class="TempPresemtItemHeader">
                                <div class="TempPresemtItemHeader-title">STA 기질검사 실시</div>
                                <div class="TempPresemtItemHeader-count">5,310명</div>
                            </div>
                            <div class="TempPresemtItemBody">
                                <div class="TempPresemtItemBodyTitle">
                                    <span class="TempPresemtItemBodyTitle-text">2024년 ~ 2025년 기준</span>
                                    <span class="TempPresemtItemBodyTitle-sub">아동부터 성인까지 다양한 사람들의 기질검사 실시</span>
                                </div>
                                <p class="TempPresemtItemBody-item">아동 및 가족 기질검사</p>
                                <p class="TempPresemtItemBody-item">심리치료, 상담의 내담자 기질검사</p>
                                <p class="TempPresemtItemBody-item">어린이집, 유치원, 사회복지기관, 학교 기질검사</p>
                            </div>
                        </div>
                    </li>
                    <li class="TempPresemt-item">
                        <div class="TempPresemtItem">
                            <div class="TempPresemtItemHeader">
                                <div class="TempPresemtItemHeader-title">STA 홈페이지용 기질검사 실시</div>
                                <div class="TempPresemtItemHeader-count">13,053명</div>
                            </div>
                            <div class="TempPresemtItemBody">
                                <div class="TempPresemtItemBodyTitle">
                                    <span class="TempPresemtItemBodyTitle-text">홈페이지 STA기질 간단검사로 대중화</span>
                                    <span class="TempPresemtItemBodyTitle-sub">2년 만에 1만명이 넘는 기질에 대한 관심</span>
                                </div>
                                <p class="TempPresemtItemBody-item">홈페이지 STA 기질검사 개발</p>
                                <p class="TempPresemtItemBody-item">스타 기질의 대중화를 위한 홈페이지 검사 개발</p>
                                <p class="TempPresemtItemBody-item">자신의 기질을 통해 타고난 성품을 발견하길 소망</p>
                            </div>
                        </div>
                    </li>
                    <li class="TempPresemt-item">
                        <div class="TempPresemtItem">
                            <div class="TempPresemtItemHeader">
                                <div class="TempPresemtItemHeader-title">STA 기질분석상담사 자격취득자</div>
                                <div class="TempPresemtItemHeader-count">105명</div>
                            </div>
                            <div class="TempPresemtItemBody">
                                <div class="TempPresemtItemBodyTitle">
                                    <span class="TempPresemtItemBodyTitle-text">STA 기질분석상담사 민간자격과정</span>
                                    <span class="TempPresemtItemBodyTitle-sub">STA 기질분석상담사 민간자격증 (주무부처 : 교육부)</span>
                                </div>
                                <p class="TempPresemtItemBody-item">STA 기초교육 수료자 500명 이상</p>
                                <p class="TempPresemtItemBody-item">STA 기질분석상담사 자격증 전문가를 위한 과정</p>
                                <p class="TempPresemtItemBody-item">쉽게 취득하는 자격증이 아닌, 6개월 과정의 전문자격</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- .TempPresemt-->
            <!-- TempHomepg-->
            <h3 class="ATempSubTitle">STA : Homepage Test
                <span class="ATempSubTitle-sub">간단 검사 타입</span>
            </h3>

            <div class="TempAssess ATempSec Type1">
                <div class="TempAssessFlex">
                    <div class="TempAssessThumb">
                        <img src="/images/view/abouttemp/abouttem4.jpg" class="TempAssessThumb-img" alt="" />
                    </div>
                    <div class="TempAssessCnt">
                        <ul class="TempAssessCnt-inner">
                            <li class="TempAssessCnt-item">
                                <div class="TempAssessCntItem">
                                    <span class="TempAssessCntItem-title">홈페이지 기질검사</span>
                                    <span class="TempAssessCntItem-sub">누구나, 언제 어디서나 실시 가능</span>
                                </div>
                            </li>
                            <li class="TempAssessCnt-item">
                                <div class="TempAssessCntItem">
                                    <span class="TempAssessCntItem-title">온라인 기질검사</span>
                                    <span class="TempAssessCntItem-sub">연구소 홈페이지 및 전화(031-469-1028) 신청 가능</span>
                                </div>
                            </li>
                        </ul>
                        <div class="TempAssessCntImg">
                            <img src="/images/view/abouttemp/abouttem5.jpg" class="TempAssessCntImg-img" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- .TempHomepg-->
             <!-- TempAssess-->
            <h3 class="ATempSubTitle">STA Assessment
                <span class="ATempSubTitle-sub">온라인 기질검사 후, 온라인 결과상담</span>
            </h3>
            <div class="TempAssess ATempSec Right">
                <div class="TempAssessFlex">
                    <div class="TempAssessThumb">
                        <img src="/images/view/abouttemp/abouttem6.jpg" class="TempAssessThumb-img" alt="" />
                    </div>
                    <div class="TempAssessCnt">
                        <ul class="TempAssessCnt-inner">
                            <li class="TempAssessCnt-item">
                                <div class="TempAssessCntItem">
                                    <span class="TempAssessCntItem-title">홈페이지 문의 : 기질검사 신청 / 전화 신청</span>
                                    <span class="TempAssessCntItem-sub">기관의 경우, 기질검사와 기질교육 함께 진행할 때 기질검사 가능<br />개인의 경우, 기질검사와 결과상담 함께 신청할 때 기질검사 가능</span>
                                </div>
                            </li>
                            <li class="TempAssessCnt-item">
                                <div class="TempAssessCntItem">
                                    <span class="TempAssessCntItem-title">결과상담은 온라인 / 오프라인 선택 가능</span>
                                    <span class="TempAssessCntItem-sub">개인 검사 및 결과상담 / 커플 검사 및 결과상담 / 가족 검사 및 결과상담</span>
                                </div>
                            </li>
                        </ul>
                        <div class="TempAssessCntImg">
                            <img src="/images/view/abouttemp/abouttem7.jpg" class="TempAssessCntImg-img" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- .TempAssess-->
             <!-- TempAssess-->
            <h3 class="ATempSubTitle">STA Assessment
                <span class="ATempSubTitle-sub">정식 검사 54문항(M type) 또는 90문항(Q type)</span>
            </h3>
            <div class="TempAssess ATempSec">
                <div class="TempAssessFlex">
                    <div class="TempAssessThumb">
                        <img src="/images/view/abouttemp/abouttem8.jpg" class="TempAssessThumb-img" alt="" />
                    </div>
                    <div class="TempAssessCnt">
                        <ul class="TempAssessCnt-inner">
                            <li class="TempAssessCnt-item">
                                <div class="TempAssessCntItem">
                                    <span class="TempAssessCntItem-title">방문 기질평가</span>
                                    <span class="TempAssessCntItem-sub">기질검사 90문항 실시, 기질관찰 (아동은 놀이, 성인은 면담), 투사그림검사 실시</span>
                                </div>
                            </li>
                            <li class="TempAssessCnt-item">
                                <div class="TempAssessCntItem">
                                    <span class="TempAssessCntItem-title">기질평가 결과상담</span>
                                    <span class="TempAssessCntItem-sub">기질평가 후 기질평가 결과에 대한 결과 상담</span>
                                </div>
                            </li>
                        </ul>
                        <div class="TempAssessCntImg">
                            <img src="/images/view/abouttemp/abouttem9.jpg" class="TempAssessCntImg-img" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- .TempAssess-->
             <!-- TempSpecial-->
            <h3 class="ATempSubTitle">STA Special feature
                <span class="ATempSubTitle-sub">STA 기질검사 특별한 지혜를 담고 있습니다.<br />하나님께서 창조하신 당신의 기질과 섬품을 발견하고 행복하길 소망합니다.</span>
            </h3>

            <div class="TempSpecial">
                <div class="TempSpecialFlex">
                    <ul class="TempSpecialFlex-inner">
                        <li class="TempSpecialFlex-item">
                            <div class="TempSpecialItem">
                                <div class="TempSpecialItem-title">에너지원</div>
                                <p class="TempSpecialItem-text">나의 에너지원은?<br />내가 에너지를 얻는 타고난 결은?<br />나의 에너지원을 이해할 때, 자기돌봄을 시작할 수 있습니다.</p>
                            </div>
                        </li>
                        <li class="TempSpecialFlex-item">
                            <div class="TempSpecialItem">
                                <div class="TempSpecialItem-title">핵심욕구</div>
                                <p class="TempSpecialItem-text">나의 핵심욕구는?<br />내가 타고난 욕구의 방향은?<br />나의 기질 핵심욕구를 이해할 때, 주관적 행복감의 비밀을 알게 됩니다.</p>
                            </div>
                        </li>
                        <li class="TempSpecialFlex-item">
                            <div class="TempSpecialItem">
                                <div class="TempSpecialItem-title">관계, 욕구특징</div>
                                <p class="TempSpecialItem-text">기질에 따른 관계특징, 욕구특징은?<br />나의 기질유형과 기질점수의 균형과 조화는 나만의 독특한 삶의 패턴을 만듭니다. 나의 패턴은 무엇일까요?</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- .TempSpecial-->
        </div>
    </div>
    <!-- .PageAbout -->

</template>
<script>
import {computed, reactive } from 'vue'
import { useHead } from '@vueuse/head'
import DownloadPdfButton from '../components/pdfdownload/pdfdownload.vue';
export default {
    name:'Intoroduction',
    setup() {
        const siteData = reactive({
        title: `STA기질검사 소개 - WithYou 위드유치료교육연구소`,
        description: 'WithYou 위드유치료교육연구소를 소개합니다.',
        canonical: 'https://withyoulove.co.kr/About/AboutTemp',
        })
        useHead({
            title: computed(() => siteData.title),
            meta: [
                    {
                        name: `description`,
                        content: computed(() => siteData.description),
                    },
            ],
            link: [
                {
                    rel: `canonical`,
                    content: computed(() => siteData.canonical),
                },
            ]
        })
    },
    components: {
        DownloadPdfButton
    },
    data() {
        return {
            //pdf
            pdfUrl: '../../uploads/STA_자기발견_기질검사.pdf',
            pdfFileName: 'STA_자기발견_기질검사.pdf',
            buttonLabel: 'STA 자기발견 기질검사 다운로드'
        };
    },
}
</script>